import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { client } from "../../../api/client";

const initialState = {
  searchProvidersLoader: false,
  providers: [],
  pdfFile: "",
  searchParams: {},
  totalCount: 0,
};

export const getSearchProviders = createAsyncThunk(
  "provider/getSearchProviders",
  async (payload) => {
    const response = await client.post(
      `/o/providersearch/searchProviders?p_auth=${window.Liferay.authToken}`,
      payload
    );
    return response;
  }
);

export const searchProvidersSlice = createSlice({
  name: "searchProviders",
  initialState,
  reducers: {
    resetPdfFile: (state) => {
      state.pdfFile = "";
    },
  },
  extraReducers: {
    [getSearchProviders.pending]: (state) => {
      state.searchProvidersLoader = true;
    },
    [getSearchProviders.fulfilled]: (state, action) => {
      state.searchProvidersLoader = false;
      state.providers = action.payload.searchProviders || [];
      state.pdfFile = action.payload.base64File || "";
      const {
        pageNumber,
        sortDirection,
        totalCount,
        sortingField,
        countrySearch,
        stateSearch,
        citySearch,
        zipSearch,
        addressSearch,
        specialitySearch,
        organizationSearch,
        isSpecialitySearch
      } = action.payload;
      const searchParamsValues = {
        pageNumber,
        sortDirection,
        totalCount,
        sortingField,
        countrySearch,
        stateSearch,
        citySearch,
        zipSearch,
        addressSearch,
        specialitySearch,
        organizationSearch,
        isSpecialitySearch
      };
      state.searchParams = searchParamsValues || {};
      state.totalCount = action.payload.totalCount || 0;
    },
    [getSearchProviders.rejected]: (state, action) => {
      state.searchProvidersLoader = false;
      state.error = action.payload;
    },
  },
});

export const { resetPdfFile } = searchProvidersSlice.actions;

export default searchProvidersSlice.reducer;
